<template>
  <span>
    <i18n-t v-if="price" keypath="From {pricePerNight}">
      <template #pricePerNight>
        <pu-price :price="price" />
        <translate
          class="price-rules"
          :tt="{ price: leadPriceNights, adultsCount: leadPriceAdults }"
        >
          For {price} night, {adultsCount} adults
        </translate>
      </template>
    </i18n-t>
  </span>
</template>

<script lang="ts">
import { SimpleMoney } from '~/utility/money'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteMapCardPrice extends Vue {
  @Prop({ required: false })
  price: SimpleMoney

  @Prop({ required: false })
  leadPriceAdults: number

  @Prop({ required: false })
  leadPriceNights: number
}

export default toNative(CampsiteMapCardPrice)
</script>

<style scoped>
.price-rules {
  white-space: normal;
  font-size: var(--body);
  color: var(--colour-text-light);
  display: block;
}
</style>
